import type { BoardModelKind } from "./kind";
import type { BoardModelDebuggable } from "./debuggable";

export type DebugFrameIdSets = {
  location: Set<string>;
  locationGroup: Set<string>;
  primary: Set<string>;
  secondary: Set<string>;
};

export function emptyDebugFrameIdSets(): DebugFrameIdSets {
  return {
    location: new Set(),
    locationGroup: new Set(),
    primary: new Set(),
    secondary: new Set(),
  };
}

export function registerDebuggableId(
  measurable: BoardModelDebuggable,
  sets: DebugFrameIdSets,
): void {
  switch (measurable.kind) {
    case "Location":
      sets.location.add(measurable.debugId);
      break;
    case "LocationGroup":
      sets.locationGroup.add(measurable.debugId);
      break;
    case "LocationPrimary":
      sets.primary.add(measurable.debugId);
      break;
    case "LocationSecondary":
      sets.secondary.add(measurable.debugId);
      break;
    default:
      break;
  }
}

export function registerDebuggableIds(
  measurables: readonly BoardModelDebuggable[],
  sets: DebugFrameIdSets,
): void {
  for (const measurable of measurables) {
    registerDebuggableId(measurable, sets);
  }
}

export function kindSet(
  sets: DebugFrameIdSets,
  kind: BoardModelKind,
): Set<string> | undefined {
  switch (kind) {
    case "Location":
      return sets.location;
    case "LocationGroup":
      return sets.locationGroup;
    case "LocationPrimary":
      return sets.primary;
    case "LocationSecondary":
      return sets.secondary;
    default:
      return undefined;
  }
}
